module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/artillery-strike.df6ce6d1.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/artillery-strike.png
// module id = 3704
// module chunks = 11